import type {CSSProperties, ReactNode} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {IFieldErrorMessageVariant, IFieldState} from "../types";
import {getFieldStateColor} from "../utils/get_field_state_color";
import {FieldErrorIcon} from "./FieldErrorIcon";

import {fieldMessageWrapper, fieldMessageWrapperAlternative} from "./FieldMessage.module.css";

interface IProps {
    children: ReactNode;
    fieldState?: IFieldState;
    className?: string;
    variant?: IFieldErrorMessageVariant;
}

export function FieldMessage(props: IProps) {
    const {children, fieldState, variant = "default"} = props;

    const fieldStateColor = getFieldStateColor(fieldState, variant);

    let messageColor = `var(${fieldStateColor})`;
    if (!fieldState || fieldState === "disabled" || fieldState === "default") {
        messageColor = "var(--colors-secondary)";
    }

    const wrapperVariables = messageColor ? ({"--field-state-color": messageColor} as CSSProperties) : undefined;
    const isAlternativeError = variant === "alternative" && fieldState === "error";
    const cn = classNames(fieldMessageWrapper, isAlternativeError && fieldMessageWrapperAlternative, props.className);

    return (
        <div style={wrapperVariables} data-name="field-message" className={cn}>
            {isAlternativeError && <FieldErrorIcon />}
            <Text variant={isAlternativeError ? "info_txt_2" : "info_txt_3"} as="span">
                {children}
            </Text>
        </div>
    );
}
import type {CSSProperties, ReactNode} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {IFieldErrorMessageVariant, IFieldState} from "../types";
import {getFieldStateColor} from "../utils/get_field_state_color";
import {FieldErrorIcon} from "./FieldErrorIcon";

import {fieldMessageWrapper, fieldMessageWrapperAlternative} from "./FieldMessage.module.css";

interface IProps {
    children: ReactNode;
    fieldState?: IFieldState;
    className?: string;
    variant?: IFieldErrorMessageVariant;
}

export function FieldMessage(props: IProps) {
    const {children, fieldState, variant = "default"} = props;

    const fieldStateColor = getFieldStateColor(fieldState, variant);

    let messageColor = `var(${fieldStateColor})`;
    if (!fieldState || fieldState === "disabled" || fieldState === "default") {
        messageColor = "var(--colors-secondary)";
    }

    const wrapperVariables = messageColor ? ({"--field-state-color": messageColor} as CSSProperties) : undefined;
    const isAlternativeError = variant === "alternative" && fieldState === "error";
    const cn = classNames(fieldMessageWrapper, isAlternativeError && fieldMessageWrapperAlternative, props.className);

    return (
        <div style={wrapperVariables} data-name="field-message" className={cn}>
            {isAlternativeError && <FieldErrorIcon />}
            <Text variant={isAlternativeError ? "info_txt_2" : "info_txt_3"} as="span">
                {children}
            </Text>
        </div>
    );
}
